import React, { useCallback, useMemo } from "react";

import { useResult } from "2g-grid";
import { Theme as WidgetTheme } from "2g-widget";
import { Icons } from "2g-icons";

import { ADMIN } from "b2b/api/paths";
import { PATHS } from "b2b/constants";
import { useRedirect } from "b2b/hooks";

import useMessages from "./i18n/useMessages";
import useColumns from "./useColumns";

export default function useProduktyGrid() {
  const columns = useColumns();
  const { title, add } = useMessages();
  const redirect = useRedirect();

  const redirectToProdukt = useCallback(
    id => {
      redirect(PATHS.ADMINISTRACE.PRODUKT, {
        id
      });
    },
    [redirect]
  );

  const handleRowClick = useCallback(
    ({ dataRow }) => {
      redirectToProdukt(dataRow.id);
    },
    [redirectToProdukt]
  );

  const handleAddClick = useCallback(() => {
    redirectToProdukt();
  }, [redirectToProdukt]);

  const titleActions = useMemo(
    () => ({
      add: () => (
        <WidgetTheme.HeaderAction key="add" onClick={handleAddClick}>
          <Icons.Plus />
          <span>{add()}</span>
        </WidgetTheme.HeaderAction>
      )
    }),
    [redirectToProdukt]
  );

  return useResult({
    title: title(),
    moduleKey: "produktyGrid",
    url: ADMIN.produkty(),
    method: "get",
    columns,
    collapsed: true,
    onRowClick: handleRowClick,
    showFilterDescription: false,
    selectable: false,
    sortable: true,
    loadOnInit: true,
    titleActions
  });
}
